import { InjectionToken } from "@angular/core";
import { ExpenseCategoriesPort } from "./expense-categories.port";

export const EXPENSE_CATEGORIES_PORT = new InjectionToken<ExpenseCategoriesPort>("EXPENSE_CATEGORIES_PORT");
